import { Component, Input, OnInit } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { FormsModule } from '@angular/forms';
import { ScenarioItemTypeNew } from '../../enums/scenario-item-type.enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-validate-response',
  standalone: true,
  imports: [MatSlideToggleModule, FormsModule, TranslateModule],
  templateUrl: './validate-response.component.html',
  styleUrl: './validate-response.component.scss',
})
export class ValidateResponseComponent implements OnInit {
  @Input() type: string;
  @Input() options: any[];
  @Input() item: any;
  @Input() maxSelectedAnswers: number;
  isCorrectAnswersVisible = false;
  max_score = 0;
  penalty_modifier = 1;
  auto_send_next_item = true;
  auto_send_next_item_delay = 5;
  scenarioItemType = ScenarioItemTypeNew;
  selectedOptions: number[] = [];
  language: string;
  correct_answer: '1' | '0' | null = '1';

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.language = this.translate.currentLang || 'en';
    if (this.item) {
      this.max_score = this.item.max_score;
      this.penalty_modifier = this.item.penalty_modifier;
      this.correct_answer = this.item?.correct_answer?.toString();
      this.isCorrectAnswersVisible = this.item.max_score > 0;
      this.auto_send_next_item = this.item.auto_send_next_item;
      this.auto_send_next_item_delay =
        this.item.auto_send_next_item_delay ?? 5;
    }
  }

  toggleOption(id, isChecked: boolean): void {
    this.options[id].is_correct = isChecked;
    const index = this.selectedOptions.indexOf(id);
    if (index > -1) {
      this.selectedOptions.splice(index, 1);
    } else {
      this.selectedOptions.push(id);
    }
  }

  isOptionSelected(optionId: number): boolean {
    return this.selectedOptions.includes(optionId);
  }

  getOptionText(option: any): string {
    if (option.body) {
      return option.body;
    }

    if (!option.descriptions) {
      return 'Option';
    }

    if (Array.isArray(option.descriptions)) {
      if (option.descriptions.length === 0) {
        return 'Option';
      }

      let description = option.descriptions.find(
        (desc: any) => desc.language === this.language
      );

      if (!description) {
        description = option.descriptions.find(
          (desc: any) => desc.language === 'en'
        );
      }

      if (!description && option.descriptions.length > 0) {
        description = option.descriptions[0];
      }

      return description?.body || 'Option';
    }

    if (typeof option.descriptions === 'object') {
      return (
        option.descriptions[this.language] ||
        option.descriptions['en'] ||
        option.descriptions[Object.keys(option.descriptions)[0]] ||
        'Option'
      );
    }

    return 'Option';
  }
}
